export enum Frequency {
  FIVE = '5 minutes',
  THIRTY = '30 minutes',
  DAILY = '1 day',
  WEEKLY = '1 week',
  MONTHLY = '1 month',
  QUARTERLY = '3 month',
  YEARLY = '1 year'
}
